var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.215.001h8.236a1.985 1.985 0 011.457.567l1.049 1.034v-.007l1.064 1.053a2.166 2.166 0 01.1 2.982l-.003.003-.003.004-2.502 2.466-.704.693-3.18 3.134a1.99 1.99 0 01-2.791 0l.44-.445-.44.445-3.18-3.134-.703-.692C1.736 6.804.565 5.652.552 5.637l-.003-.004-.003-.003a2.165 2.165 0 01.1-2.982L1.71 1.595v.007L2.759.568A1.983 1.983 0 014.215.001zM1.488 3.575a.914.914 0 00-.012 1.22 2237.875 2237.875 0 013.16 3.11l3.18 3.134-.422.429.422-.429c.141.14.327.21.517.211.19 0 .377-.071.518-.21l.438.444-.438-.445 3.18-3.133.929-.915 2.23-2.196a.915.915 0 00-.011-1.22L13.03 1.459a.733.733 0 00-.546-.208H4.181a.733.733 0 00-.545.208L1.488 3.575z",
    fill: "#ED0059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58.626C3.58.28 3.86 0 4.204 0h8.256a.626.626 0 01.024 1.252.73.73 0 00-.49.208L9.728 3.694c-.771.76-2.018.76-2.79 0L4.672 1.46a.733.733 0 00-.49-.21.626.626 0 01-.603-.625zm2.66.624l1.575 1.553a.743.743 0 001.036 0m0 0l1.577-1.553H6.239",
    fill: "#ED0059"
  })));
}

export default SvgAme;